import React from 'react';
import { useTranslation } from 'react-i18next';
import { filterIcons } from './assets';
import NoResults from '../no-results';

const NoFilterResults = ({ onReset }: any) => {
  const { t } = useTranslation();

  return (
    <NoResults
      illustration={filterIcons.empty}
      info={t('v2.dashboard.section_eventList_label_emptyState')}
      resetLabel={t('v2.dashboard.section_eventList_button_label_emptyState')}
      onReset={onReset}
    />
  );
};

export default NoFilterResults;
